/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PageMetadata } from './page-metadata';
import { TipoPraticaDocumentoDTO } from './tipo-pratica-documento-dto';


export interface PagedModelTipoPraticaDocumentoDTO { 
    content?: Array<TipoPraticaDocumentoDTO>;
    page?: PageMetadata;
}

